// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"QQ-z","smallCardRow":"RQ-z","largeCardRow":"SQ-z","productSearchRow":"TQ-z","curatedRow":"UQ-z"};